module.exports = __webpack_public_path__ + "static/media/hub-gray.30fdc3de.svg";